module.exports = __webpack_public_path__ + "static/img/3.86ccb1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Conference/3.png
// module id = blu1
// module chunks = 1